import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { readablizeBytes, invalidateUrl } from '@appbase/util'
import * as typesAccount from '@account/store/types'
import * as types from '@mail/store/types'
import { mapGetters } from 'vuex'
import fileViewer from '@appbase/util/doc-viewer-helper'
import ProgressRing from '@/components/common/ProgressRing.vue'
import api from '@mail/api'

const md5 = require('md5')

const images: { [key: string]: string[] } = {
  doc: ['docx', 'docm', 'doc', 'dotx', 'dotm', 'dot', 'rtf'],
  excel: ['xlsx', 'xlsm', 'xlsb', 'xls', 'csv', 'xltx'],
  ppt: ['pptx', 'pptm', 'ppt', 'potx', 'potm', 'pot', 'ppsx', 'ppsm', 'pps'],
  img: ['png', 'jpg', 'jpeg', 'gif'],
  pdf: ['pdf'],
  txt: ['txt', 'log', 'xml'],
  zip: ['zip', '7z', 'gz'],
}

@Component({
  components: {
    ProgressRing,
  },
  computed: {
    ...mapGetters({
      user: typesAccount.USER,
      currentEmail: types.EMAIL_SELECT
    }),
  },
})
export default class ReadAttachment extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Array }) item!: mail.EwsAttachment[]
  //@Prop({ type: Object }) item!: mail.EmailMessage;
  @Prop({ type: String }) id!: string

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  user!: account.User
  currentEmail!: mail.EmailMessage

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  isLoading: boolean = true;
  loadingMessage: string = 'Decryption is in progress.';

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  getSize(size: number) {
    return readablizeBytes(size)
  }

  // download -> preview로 변경 2024.01.15
  preview(attachment: any) {
    const { email } = this.user
    var itemId = ""
    var fileId = ""
    if(this.CheckDocumentExtension(attachment.name))//ms office문서만체크
    {
      itemId = this.id
      fileId = attachment.id
      api.mail.getArticleFile(fileId).then((res: any) => {
        if (res && res.length) {
          if (res[0].exportStatus == 'Y'){
            fileViewer.open(res[0].name, res[0].exportUrl, true)
          }
        }
        else{
          this.isLoading = false;
          api.mail.createExportEmailFile(itemId, fileId, '').then(res => {
              var intervalCount = 10;
              var trigger = setInterval(() => {
                  api.mail.getArticleFile(fileId).then((resFile: any) => {
                      intervalCount--;
                      if (resFile && resFile.length) {
                          if (resFile[0].exportStatus == 'Y')
                          {
                              this.isLoading = true
                              clearInterval(trigger)
                              fileViewer.open(resFile[0].name, resFile[0].exportUrl, true)
                          }
                      } 
                  })
              }, 2000)
          });
        } 
      })
    }
    else{
      const base = invalidateUrl('/cm/mailews/attachment/api/email')
      itemId = encodeURIComponent(this.id)
      fileId = encodeURIComponent(attachment.id)
      var url = `${base}?itemId=${itemId}&attachmentID=${fileId}&email=${email}`
      fileViewer.open(attachment.name, url, true)
    }
  }

  //다운로드 추가 2024.01.15
  download(attachment: any) {
    const { email } = this.user
    // let iframe = document.getElementById('fileDownload') as HTMLIFrameElement
    
    const itemId = encodeURIComponent(this.id)
    const fileId = encodeURIComponent(attachment.id)
    
    // iframe.src = url
    let _osCheck = navigator.userAgent;
    if(_osCheck.includes('Mac')) {
        const base = invalidateUrl('/cm/File/ISU_File/api/mobileios')
        const url = `${base}?itemId=${itemId}&attachmentID=${fileId}&user=${email}`

        if(_osCheck.includes('Safari') || this.isTeams == true) {    
          let _a = document.createElement('a');
          _a.target = '_blank';
          _a.href = url;
          document.body.appendChild(_a);
          _a.click();  
        } else { //팀플러스 앱으로 접속 한 경우 2024.02.27 
          (window as any).dsmobileapp.web2app('link','download', {'url':url, 'filename': attachment.name})
        }

    }else{
        const base = invalidateUrl('/cm/File/ISU_File/api/mobile')
        const url = `${base}?itemId=${itemId}&attachmentID=${fileId}&user=${email}`

        location.href = url;
    }
  }

  CheckDocumentExtension(filename: string){
    var fileExtension = filename.substring(filename.lastIndexOf(".")).split('.')[1].toUpperCase();
    var value = false;
    if (fileExtension == "DOCX"
        || fileExtension == "PPTX"
        || fileExtension == "XLSX"
    ) {
        value = true;
    }
    return value;
  }

  imageUrl(file: mail.EwsAttachment) {
    const ext = this.getExtensions(file.name)
    var aa = 'default'
    if (ext) {
      var key = Object.keys(images).find((key: string) => {
        var supports = images[key]
        return supports.includes(ext?.toLowerCase())
      })
      if (key) {
        aa = key
      }
    }
    return `/cm/gres/v1/img/type_${aa}.png`
  }

  getExtensions(filename: string) {
    return filename.split('.').pop()
  }
}
